const localizers = {
  'loading.msg': () => `Laster inn...`,
  'logon.message.msg': () => `Godkjenning kreves. Tast inn gyldig bruker-ID og passord.`,
  'logon.button.msg': () => `Pålogging...`,
  'SASServer.logonError.msg': () => `Kan ikke logge på til tjeneren.`,
  'SASServer.genericError.msg': () => `Tjeneren kan ikke nås.`,
}
export default localizers;
